import AsideMenu from "../aside-menu/aside-menu";
import EventsHelper from "../../common/js/eventsHelper";

export default new class Header {
    constructor() {
        this.header = ".fs-header";

        if (!document.querySelector(this.header)) return;

        this.navSearchItem = "[data-header-nav-search]";
        this.searchClose = ".fs-header-search--close";
        this.searchInputClass = ".fs-header-search--input";
        this.mobileMenu = document.querySelector(".fs-header--mobile-menu");
        this.mobileMenuClose = document.querySelector(".fs-header--mobile-menu-close");
        this.searchOverlay = document.querySelector(".fs-header-search-overlay");
        this.search = document.querySelector(".fs-header-search");
        this.searchMobile = document.querySelector(".fs-header--mobile-search");
        this.navItemList = document.querySelectorAll(".fs-header--nav-item");
        this.searchInput = document.querySelector(this.searchInputClass);
        this.mobileNav = document.querySelector(".fs-header--mobile");
        this.mobileNavNodeList = [...this.mobileNav.childNodes].filter(x => x.nodeType == 1);

        this.classShow = "fs--show";
        this.classHide = "fs--hide";
        this.classHideMobile = "fs--hide-mobile";
        this.classOpen = "fs--open";
        this.fadeSpeed = 50;
        this.transition = 200;

        this.attachEvents();
    }

    attachEvents() {
        document.querySelector(this.navSearchItem).addEventListener("click", this.handleOnOpenSearch);
        document.querySelector(this.searchClose).addEventListener("click", this.handleOnCloseSearch);

        this.searchMobile.addEventListener("click", this.handleOnSearchMobileClick);
        this.mobileMenu.addEventListener("click", this.handleOnMobileMenuClick);
        this.mobileMenuClose.addEventListener("click", this.handleOnMobileMenuClick);
        this.searchOverlay.addEventListener("click", this.handleOnCloseSearch);
        this.search.addEventListener("submit", this.handleOnFormSubmit);
    }

    handleOnMobileMenuClick = e => {
        let btn = e.currentTarget;

        
        btn.classList.contains(this.classOpen) ? AsideMenu.openMenu() : AsideMenu.closeMenu();

        this.mobileMenu.classList.toggle(this.classHide);
        this.mobileMenuClose.classList.toggle(this.classShow);
    };

    handleOnFormSubmit = e => {
        e.preventDefault();
        const input = e.target.querySelector(this.searchInputClass);
        window.location.href = `/search?query=${input.value}`;
    };

    handleOnSearchMobileClick = e => {
        e.preventDefault();
        const totalTimeout = this.fadeSpeed * this.mobileNavNodeList.length;

        this.animateItems();
        EventsHelper.hideScrollBar();
        this.showSearch(totalTimeout);
        this.searchOverlay.classList.add(this.classShow);
    };

    handleOnOpenSearch = e => {
        e.preventDefault();
        const totalTimeout = this.fadeSpeed * this.navItemList.length;

        EventsHelper.hideScrollBar();
        this.searchOverlay.classList.add(this.classShow);
        this.animateItems(this.navItemList);
        this.showSearch(totalTimeout);
        document.addEventListener("keydown", this.handleOnEscPress);
    };

    handleOnCloseSearch = e => {
        e.preventDefault();
        EventsHelper.returnScrollBar();
        this.search.classList.remove(this.classShow);
        this.searchOverlay.classList.remove(this.classShow);

        setTimeout(this.animateItems, this.transition);

        document.removeEventListener("keydown", this.handleOnEscPress);
    };

    handleOnEscPress = e => {
        if (e.keyCode == 27) this.handleOnCloseSearch(e);
    };

    animateItems = () => {
        this.navItemList.forEach((item, i) => {
            setTimeout(() => item.classList.toggle(this.classHide), this.fadeSpeed * i);
        });

       this.mobileNavNodeList.forEach((item, i) => {
            setTimeout(() => item.classList.toggle(this.classHideMobile), this.fadeSpeed * i);
        });
    };

    showSearch(totalTimeout) {
        setTimeout(() => this.search.classList.add(this.classShow), totalTimeout);
        setTimeout(() => this.searchInput.focus(), totalTimeout + this.transition * 2);
    }
};
